import { Image } from '@/features/shared/elements/Image/NextImage'
import { NextLink } from '@/features/shared/elements/Link'
import { type Endcap } from '@/features/shop/services/Search/types'
import styled from 'styled-components'
import { Button } from '@shipt/design-system-buttons'
import { Body } from '@shipt/design-system-typography'
import { screenSizes } from '@shipt/design-system-themes'
import { Column } from '@shipt/design-system-layouts'

type EndcapV2Props = {
  endcap: Pick<Endcap, 'click_uri' | 'image_background_url' | 'title' | 'action_text'>
  onClick: () => void
}

export const EndcapV2 = ({ endcap, onClick }: EndcapV2Props) => {
  const { click_uri, image_background_url, title, action_text } = endcap

  return (
    <NextLink href={click_uri} onClick={onClick} aria-label={`${title}, ${action_text}`}>
      <Container>
        <ImageBox>
          <EndcapImage
            src={image_background_url}
            alt={title}
            fill
            sizes="(min-width: 1080px) 210px, 154px"
          />
        </ImageBox>
        <Column align="start" spacing="sm">
          <Body size="sm">Sponsored</Body>
          <Body strong lineHeight="compact">
            {title}
          </Body>
          <Button variant="secondary" size="sm" fullWidth forwardedAs="div">
            {action_text}
          </Button>
        </Column>
      </Container>
    </NextLink>
  )
}

const TILE_BASE = '9.625rem'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  max-width: ${TILE_BASE};

  @media ${screenSizes.tablet} {
    max-width: 18rem;
  }
`

const ImageBox = styled.div`
  position: relative;
  overflow: hidden;
  aspect-ratio: 1 / 1;
  border-radius: 8px;

  @media ${screenSizes.smDesktop} {
    height: 13.125rem;
    width: 13.125rem;
  }
`

const EndcapImage = styled(Image)`
  object-fit: cover;
`
